/** @format */

import {
  isMobile as isMobileFromUA,
  isTablet as isTabletFromUA,
  isMobileOnly as isMobileOnlyFromUA
} from 'react-device-detect';

export const MOBILE_MAX_WIDTH_PX = 767;
const TABLET_MIN_WIDTH_PX = 768;
const SMALL_TABLET_MAX_WIDTH_PX = 1023;
export const TABLET_MAX_WIDTH_PX = 1439;

export interface DeviceDetectSnapshot {
  isMobile: boolean;
  isTablet: boolean;
  isSmallTablet: boolean;
  isMobileOnly: boolean;
  isIPad: boolean;
}

/**
 * iPadOS 13+ often reports as Macintosh (desktop Safari UA), so react-device-detect misses isTablet.
 * @see https://developer.apple.com/forums/thread/119186
 */
const isIPad = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  if (/iPad/i.test(navigator.userAgent)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};

const readViewportWidth = (): number => (typeof window !== 'undefined' ? window.innerWidth : 0);

export const getDeviceDetectSnapshot = (): DeviceDetectSnapshot => {
  const ipad = isIPad();
  const width = readViewportWidth();

  if (width > 0) {
    const isMobile = width <= MOBILE_MAX_WIDTH_PX;
    const isTablet = ipad || (width >= TABLET_MIN_WIDTH_PX && width <= TABLET_MAX_WIDTH_PX);
    return {
      isMobile,
      isTablet,
      isSmallTablet: width >= TABLET_MIN_WIDTH_PX && width <= SMALL_TABLET_MAX_WIDTH_PX,
      isMobileOnly: isMobile && !ipad,
      isIPad: ipad
    };
  }

  return {
    isMobile: !ipad && isMobileFromUA,
    isTablet: isTabletFromUA || ipad,
    isSmallTablet: false,
    isMobileOnly: ipad ? false : isMobileOnlyFromUA,
    isIPad: ipad
  };
};
